module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "image5c"
  }, [_c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "234",
      "src": "images/f002.jpg",
      "width": "350"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("So, who do you want to be when you grow up? Not "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("what")]), _vm._v(" do you want to be, but "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("who")]), _vm._v(" do you want to be? What kind of person do you want to become? What legacy do you want to leave behind? What is your passion? Your calling?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("If you were stranded on a deserted island where money, time, people, and resources were not an issue and you were told to choose one thing—one task—to do, what would that be?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Let me give you a little hint: it’s not all about the money. When I ask young adults what career they’re going to choose, the most popular response is “I don’t know. I just want to make lots of money.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_vm._v("Do a job for fifteen years just for the money and your life will be the equivalent of eating cold, stale french fries every morning. Dreary. Do something you’re passionate about or that you feel ")]), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_vm._v("called to do, and then success, contentment—and perhaps money—are possible.")])]), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Don’t have a clue? That’s okay. That’s what this time in your life is all about. Explore your options. Gain experiences. Read chapter 60 about volunteering and broadening your world of possibilities.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Okay, now down to 10,000 feet.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Goals are simply dreams written down on paper. They’re destinations at which we wish to arrive. Goals don’t have to be set in stone. Life happens, and things change. Goals just start us down a path and help us to look up from our feet to the horizon of the future.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("You can start small, with goals for this month, and work your way up to the bigger stuff. Try listing some things you’d like to accomplish in various stages using the list below.")]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("My goals")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("For the next thirty days: ___________________________________")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("_____________________________________________________")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("For the next three months: _________________________________")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("_____________________________________________________")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("For the next six months: ___________________________________")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("_____________________________________________________")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  })]), _c('div', {
    staticClass: "sidebar"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_c('p', {
    staticClass: "sidebartit"
  }, [_vm._v("Resources to help discern your gifts, passions, career options")]), _vm._v(" "), _c('p', {
    staticClass: "indenthanging"
  }, [_vm._v("• "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("What You Do Best in the Body of Christ")]), _vm._v(" by Bruce L. Bugbee")]), _vm._v(" "), _c('p', {
    staticClass: "indenthanging"
  }, [_vm._v("• "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("S.H.A.P.E.: Finding and Fulfilling Your Unique Purpose for Life")]), _vm._v(" by Erik Rees")])]), _c('p', {
    staticClass: "indenthanging"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_vm._v("• Myers-Briggs Type Indicator (")]), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "http://www.myersbriggs.com",
      "target": "_blank"
    }
  }, [_vm._v("www.myersbriggs.org")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "indenthanging"
  }, [_vm._v("• "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("48 Days to the Work You Love")]), _vm._v(" by Dan Miller ("), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "http://www.48days.com",
      "target": "_blank"
    }
  }, [_vm._v("www.48days.com")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_vm._v("For the next year: __________________________________")])]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("________________________________________________")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("For five years from now: _____________________________")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("________________________________________________")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("For ten years from now: _____________________________")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("________________________________________________")]), _vm._v(" "), _c('p', {
    staticClass: "h4"
  }, [_vm._v("What I need to do to reach my goals")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("1. ________________________________________________")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("2. ________________________________________________")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("3. ________________________________________________")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("4. ________________________________________________")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("5. ________________________________________________")]), _vm._v(" "), _c('p', {
    staticClass: "h4"
  }, [_vm._v("Things I need to avoid in order to reach my goals")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("1. ________________________________________________")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("2. ________________________________________________")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("3. ________________________________________________")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("4. ________________________________________________")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("5. ________________________________________________")]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("Priorities")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Now that you’ve set some goals for yourself, it’s time to set priorities. Your priorities will determine how you spend your time, your resources, and your gifts—in other words, how you live your life as you try to achieve your goals.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("Rank the following items, 1 being the most important thing to you, 11 being the least important.")])]), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_c('p', {
    staticClass: "indent"
  }), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("___ God, spiritual life")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("___ Spouse/boyfriend/ girlfriend")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("___ Education")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("___ Serving others")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("___ Friends")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("___ Free time/entertainment")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("___ Family")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("___ Money")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("___ Work")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("___ Physical health")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("___ Housework")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("All eleven items will more than likely be part of your life. The key is finding the proper balance. Priorities help us to find and keep that balance.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("What was your first priority? _________________________")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Why? __________________________________________")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("_______________________________________________")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("How are you going to keep that priority? ________________")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("_______________________________________________")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("What was number 11? _____________________________")]), _vm._v(" "), _c('p', {
    staticClass: "inondent"
  }, [_vm._v("Why? ___________________________________________")]), _vm._v(" "), _c('p', {
    staticClass: "inondent"
  }, [_vm._v("What do you need to do to keep your priorities in balance?")]), _vm._v(" "), _c('p', {
    staticClass: "inondent"
  }, [_vm._v("________________________________________________")]), _vm._v(" "), _c('p', {
    staticClass: "inondent"
  }, [_vm._v("________________________________________________")]), _vm._v(" "), _c('p', {
    staticClass: "inondent"
  }, [_vm._v("________________________________________________")]), _vm._v(" "), _c('div', {
    staticClass: "sidebar"
  }, [_c('p', {
    staticClass: "sidebartit"
  }, [_vm._v("Idea!")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("When life is busy, one way to balance your priorities is to combine them. Serve others with a group of friends. Work as an intern in the area of your college major and receive credit.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-728235ae","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch01.vue
// module id = 84
// module chunks = 0